module.exports = __webpack_public_path__ + "img/RefreshIcon.059af281.svg";